// extracted by mini-css-extract-plugin
module.exports = {"toggle-to-sms":"_0a3a94f455--toggle-to-sms--JG5Dn"};